import React from "react";

const BackgroundLight: React.FC = () => {
  return (
    <svg
      width="435"
      height="307"
      viewBox="0 0 435 307"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_15274_2151)">
        <path
          d="M265.127 174.973C201.473 198.208 204.101 184.58 138 199.315C43.5443 220.371 20 307 20 307L435 307L435 16C435 16 389.303 18.5043 361.985 47.5542C334.666 76.6041 319.59 155.092 265.127 174.973Z"
          fill="#C4EEFD"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15274_2151"
          x="0"
          y="0"
          width="455"
          height="331"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15274_2151"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15274_2151"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default BackgroundLight;
